import { mapGetters } from 'vuex'

export const authComputed = {
  ...mapGetters([
    'loggedIn',
    'loggedUserIsAdmin',
    'loggedUserPersonId',
    'loggedUserAvatarFilename',
    'loggedUserPersonName'
  ])
}

export const adminOptionsComputed = {
  ...mapGetters(['adminMode'])
}
